import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {Store, Timer} from '@gongxigames/framework/core';
import {$SpinBtnUi} from './components/SpinBtnUi';
import {Container} from 'pixi.js';
import {slotStore, strictUiEmitter} from '@gongxigames/framework/slotV2/globals';
import {specialInfoZoneStore} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/specialInfoZoneStore';

export class SpinButtonModule extends UIModuleV2 {
    public static NAME = 'SpinButtonModule';
    public static layer = LAYERS.KEYPAD;

    private readonly HOLD_DELAY = 3000;
    private holdActionTimer?: Timer;

    private autoplayRoundsLeft = Store.computed(() => slotStore.autoplayOptions.value?.autoplaySpins || 0);

    public container = new Container();

    protected onInit(): void {
        const spinBtn = $SpinBtnUi({
            jurisdictionZoneHeight: specialInfoZoneStore.blackPanelHeight,
            disabled: slotStore.spinBtn_btnDisabled,
            mode: slotStore.spinBtn_btnMode,
            fsCurrent: slotStore.spinBtn_fsCurrent,
            fsTotal: slotStore.spinBtn_fsTotal,
            autoplayRoundsLeft: this.autoplayRoundsLeft,
            pointerUp: this.onPointerUp.bind(this),
            pointerDown: this.onPointerDown.bind(this),
        }) as Container;

        this.container.addChild(spinBtn);
    }

    onSetupEvents(): void {
        strictUiEmitter.on('General.UI.SPACEBAR_UP', this.onPointerUp.bind(this, true));
        strictUiEmitter.on('General.UI.SPACEBAR_DOWN', this.onPointerDown.bind(this));
    }

    private onPointerDown(): void {
        this.holdActionTimer = this._updateManager.addTimer(() => this.execHoldAction(), this.HOLD_DELAY, true);
    }

    private onPointerUp(): void {
        if (!this.holdActionTimer) {
            return;
        }

        this.holdActionTimer?.stop();
        this.holdActionTimer = undefined;

        this.execClickAction();
    }

    private execClickAction() {
        const {spinBtn_btnSkipEnabled, spinBtn_btnQuickStopEnabled, spinBtn_btnMode} = slotStore.values();

        slotStore.soundPlayer.value?.play('spinclick');
        // TODO different for koala and ruby
        // for ruby - stop autoplay, for koala - stop current spin

        if (spinBtn_btnMode === 'autoplay') {
            this.emitter.emit('UI.stopAutoplayButton.pressed');

            return;
        }

        if (spinBtn_btnSkipEnabled) {
            this.emitter.emit('UI.skipButton.pressed');
            this.emitter.emit('General.disableSpinButton');

            return;
        }

        if (spinBtn_btnQuickStopEnabled) {
            this.emitter.emit('UI.quickStopButton.pressed');
            this.emitter.emit('General.disableSpinButton');

            return;
        }

        this.emitter.emit('UI.spinButton.pressed');
    }

    private execHoldAction() {
        this.holdActionTimer = undefined;

        if (slotStore.spinBtn_btnMode.value === 'base') {
            this.emitter.emit('UI.autoplayButton.pressed');
        }
    }
}